const authorizedDealer = {
  authorizedDealer: {
    dealerId: 'Sous-traitant autorisé',
    city: 'Ville',
    state: 'État',
    country: 'Pays',
    noDealer: '** Aucun sous-traitant autorisé disponible **',
    heading: 'Sous-traitant autorisé',
    addDealerButton: '+ Ajouter un sous-traitant autorisé',
    cancel: 'ANNULER',
    addSubcontractor: 'AJOUTER UN SOUS-TRAITANT',
    searchContractor: 'RECHERCHER UN SOUS-TRAITANT',
    show: 'Affiche',
    to: 'à',
    of: 'sur',
    delete: 'Supprimer',
    name: 'Nom',
    enabled: 'Activé',
    disabled: 'Désactivé',
    status: 'Statut',
    footer: 'Sous-traitants autorisés'
  }
};

export default authorizedDealer;
